import { useStyletron } from '@thanx/uikit/theme'
import blocksPreview from 'assets/images/cms/homepage-content-blocks.png'
import { buildTranslate } from 'locales'
import React from 'react'
import PublishButton from '../PublishButton'

type Props = {
  isLoading: boolean
  disabled?: boolean
}

const t = buildTranslate('cms.content.content_blocks')

const Sidebar: React.FC<Props> = ({ isLoading, disabled }) => {
  const [css] = useStyletron()

  return (
    <>
      <PublishButton
        isLoading={isLoading}
        publishText={t('publish')}
        disabled={disabled}
      />
      <img
        className={`mb-xl ${css({
          width: '200px',
          height: '397px',
        })}`}
        src={blocksPreview}
        alt={t('locations_preview')}
      />
    </>
  )
}

export default Sidebar
